import React, { useState, useRef, useEffect } from "react";
import DestructiveButton from './controls/DestructiveButton';
import { Sortable } from './DragDrop';
import { deepMap, hydrate, Panel, Content } from "./DataStructures";
import { ShrinkToFit } from '@bittnerdevelopmentgroup/interactive';
import ErrorBoundary from "./ErrorBoundary";
import { uniqueId } from "./util";
import InteractiveRenderer from "./InteractiveRenderer";
import Button from "react-bootstrap/Button";
import { propTypes } from "react-bootstrap/esm/Image";
const DEBUG = false;
const PanelListItem = /*#__PURE__*/React.memo(function PanelListItem({
  panel,
  i,
  data,
  onClick,
  onChanged,
  selectedPage,
  onDrop,
  theRef,
  focusToolboxSearch,
  focusSettingsButton,
  toggleInDropdown,
  ...rest
}) {
  const onDuplicate = React.useCallback(() => {
    let cloned = JSON.parse(JSON.stringify(data.panels[i]));
    let hydrated = deepMap(cloned, hydrate);
    hydrated._ibuid = undefined;
    data.panels.splice(i, 0, hydrated);
    onChanged();
  }, [data.panels, i]);
  const handleKeyDown = e => {
    DEBUG && console.log("PanelListItem handleKeyDown", e.key);
    if (e.key === "Enter") onClick(i);else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (0 < toolbarCursor) setToolbarCursor(toolbarCursor - 1);else if (0 == toolbarCursor) resetFocus();
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (toolbarCursor < toolbarRefs.current.length - 1) {
        setToolbarCursor(toolbarCursor + 1);
        setOutOfFocus(false);
      }
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Tab') resetFocus();
  };

  // Generate toolbar button refs
  const toolbarRefs = useRef([]);
  toolbarRefs.current = Array(2).fill(0).map((ref, i) => toolbarRefs.current[i] = /*#__PURE__*/React.createRef());
  // toolbar cursor
  const [toolbarCursor, setToolbarCursor] = useState(-1);
  const [outOfFocus, setOutOfFocus] = useState(true);
  // when toolbarCursor changes, change focus
  useEffect(() => {
    if (toolbarCursor == -1 && outOfFocus) {
      toggleInDropdown();
    } else if (!outOfFocus) {
      toolbarRefs.current[toolbarCursor].current.focus();
      setOutOfFocus(false);
    }
  }, [toolbarCursor]);
  useEffect(() => {
    DEBUG && console.log(`PanelListItem ${i} out of focus`, outOfFocus);
  }, [outOfFocus]);
  const resetFocus = () => {
    setOutOfFocus(true);
    setToolbarCursor(-1);
  };
  const onDelete = React.useCallback(() => {
    DEBUG && console.log("removing", i, data.panels);
    data.panels.splice(i, 1);
    DEBUG && console.log("removed", i, data.panels);
    if (data.panels.length === 0) {
      data.panels.push(new Panel({
        children: new Content(new Element({
          tagName: 'p',
          children: new Content('Insert text here')
        }))
      }));
    }
    onClick(Math.max(0, i - 1));
    onChanged();
  }, [data.panels, onClick, i]);
  const onClickCallback = React.useCallback(e => {
    e.stopPropagation();
    e.preventDefault();
    onClick(i);
  }, [onClick, i]);
  const onMoveCallback = React.useCallback((fromIndex, toIndex) => {
    DEBUG && console.log("dragDrop PanelList onMove", fromIndex, toIndex);
    if (toIndex !== fromIndex) {
      const temp = data.panels[fromIndex];
      data.panels.splice(fromIndex, 1);
      data.panels.splice(toIndex, 0, temp);
    }
    onClick(toIndex);
  }, [data.panels, onClick]);
  return /*#__PURE__*/React.createElement("div", {
    className: "panel-wrapper centered"
  }, i + 1, ".", " ", /*#__PURE__*/React.createElement(Sortable, {
    type: "Panel",
    key: uniqueId(panel),
    id: uniqueId(panel),
    index: i,
    className: selectedPage === i ? "page-preview selected" : "page-preview",
    onClick: onClickCallback,
    onMove: onMoveCallback,
    onDrop: onDrop,
    horizontal: true
  }, /*#__PURE__*/React.createElement(ShrinkToFit, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(InteractiveRenderer, {
    style: {
      pointerEvents: 'none'
    },
    storageKey: `panel-${uniqueId(panel)}`,
    fullWidth: true,
    key: panel.tagName + "-" + i,
    data: panel,
    attributes: {
      noFocus: true
    }
  }))), /*#__PURE__*/React.createElement(DestructiveButton, {
    size: "sm",
    variant: "danger",
    title: "Remove panel",
    text: /*#__PURE__*/React.createElement("i", {
      className: "bi bi-trash"
    }),
    confirmation: /*#__PURE__*/React.createElement("i", {
      className: "bi bi-question-lg"
    }),
    className: "remove-panel fs-sm",
    onClick: onDelete
  }), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "primary",
    title: "Duplicate Panel",
    className: "duplicate-panel fs-sm",
    onClick: onDuplicate
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-intersect"
  }))));
});
export default PanelListItem;